export class Document {
  id: number;
  name: string;
  content: string;
  isDefault: boolean;

  constructor() {
    this.name = "";
    this.content = "";
    this.isDefault = false;
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/document/document.model.ts